import React from 'react';
import PropTypes from 'prop-types';
import AdaptiveTrait from '../../AdaptiveTrait';
import style from '@src/js/Style';
import Slider from '../Base/Slider';
import Card from '../Base/Card';
import Api from '../../Api';

export default class List extends React.Component {

    constructor(props) {

        super(props);

        new AdaptiveTrait(this);

        this.state = {
            items: [],
        };
    }
    
    static get propTypes() {

        return {
            posts: PropTypes.any,
            className: PropTypes.string,
        };
    }

    componentDidMount() {

        const ids = this.getPostsIds();
        if (ids.length > 0) {

            const link = new URL(`${Api.origin}/api/v2/blog/posts.json`);
            link.searchParams.append('ids', ids.join(','));

            Api
                .fetch(link)
                .then((context) => {
                    
                    this.setState({ items: context.items });
                });
        }
    }

    renderMobile() {

        if (this.getPostsIds().length < 1)
            return null;

        const classes = [style('flex flex-wrap gap w-full')];
        if (this.props.className)
            classes.push(this.props.className);

        return (
            <div className={ classes.join(' ') }>
                { this.generateListMobile() }
            </div>
        );
    }

    renderDesktop() {

        if (this.getPostsIds().length < 1)
            return null;

        const classes = [];
        if (this.props.className)
            classes.push(this.props.className);

        return (
            <Slider className={ classes.join(' ') } count={ 3 }>
                { this.generateListDesktop() }
            </Slider>
        );
    }

    getPostsIds() {

        if (this.props.posts == undefined)
            return [];

        const type = typeof(this.props.posts);
        if (type == 'string')
            return Array.from(JSON.parse(this.props.posts)).map((el) => el.id);

        if (type == 'array')
            return this.props.posts;

        if (type == 'object')
            return Object.values(this.props.posts);

        throw new Error(`Unknown posts prop type: ${type}`);
    }

    generateListDesktop() {

        return this.state.items
            .map((post) => this.renderItemDesktop(post));
    }

    generateListMobile() {

        return this.state.items
            .slice(0, 3)
            .map((post) => this.renderItemMobile(post));
    }

    renderItemDesktop(post) {

        return <Card key={ post.id }>{ this.renderItemMobile(post) }</Card>;
    }

    renderItemMobile(post) {

        const image = post.imageUri
            ? <img className={ style('size-64 desktop:size-200 aspect-square object-contain') } src={ post.imageUri } alt={ post.name } />
            : <div className={ style('size-64 desktop:size-200 aspect-square') }></div>;

        return (
            <div key={ post.id } className={ style('flex items-center gap w-full desktop:flex-wrap') }>
                
                { image }

                <div className={ style('flex flex-wrap') }>
                    <a className={ style('w-full text-bold text-black') } href={ post.uri }>
                        { post.name }
                    </a>
                    <span className={ style('text-muted text-small mt-2') }>
                        { post.date }
                    </span>
                </div>

            </div>
        );
    }

}